<template>
    <div class="remarkContainer">
      <textarea v-model="comment" maxlength="100" :placeholder="placeholder" class="remarks-boder" @input="changeComment()"></textarea>
      <div style="color: #787878;margin-top: .1rem; margin-left: .2rem" class="fs-28">快捷标签</div>
      <div class="remark-tag">
        <div class="tag-items ellipse" v-for="item in remarkList" @click="addTips(item)">{{item}}</div>
      </div>
      <div class="btn btn-main btn-lg btn-block" style="margin: .2rem auto; width: 7.1rem;" @click="toOrder()">完 成</div>
    </div>
</template>

<script>
    export default {
        name: "OutRemarks",
        data() {
          return {
            comment: '',
            remarkList: [],
            placeholder: '',
          }
        },
        created() {
          var _this = this;

          if(window.localStorage.getItem('orderPreviewInfo')) {
            // console.log(JSON.parse(window.localStorage.getItem('orderPreviewInfo')))
            var data = JSON.parse(window.localStorage.getItem('orderPreviewInfo'))
            if(data.usedRemarkTag && data.usedRemarkTag.length){
              let list = data.usedRemarkTag
              if(list.length > 10){
                list = list.splice(0,10)
              }
              for(let i = 0;i < data.recommendRemarkList.length;i++){
                if(data.recommendRemarkList[i]){
                  list.push(data.recommendRemarkList[i])
                }
              }
              _this.remarkList = list
            }else{
              _this.remarkList = data.recommendRemarkList
            }
          }
          let val = window.localStorage.getItem('remarks')
          if(val){
            _this.comment = val
          }else{
            _this.comment = ''
            _this.placeholder = data.orderRemarkColumn ? data.orderRemarkColumn : '请填写口味偏好，推荐无接触配送，将商品放在楼下或寝室门口～'
          }
        },
        methods: {
          toOrder(){
            window.localStorage.setItem('remarks', this.comment)
            this.$router.push({name: 'OrderSettle'})
          },
          addTips(val){
            // console.log(val);
            if(this.comment == ''){
              this.comment = this.comment + val
            } else {
              this.comment = this.comment + ',' + val;
            }
            this.comment = this.comment.slice(0,100)
            if(this.comment.length>=100){
              this.$toast({
                message: '备注最多输入100字哦',
                duration: 500
              });
            }
          },
          changeComment(){
            // console.log(this.comment.length)
            if(this.comment.length>=100){
              this.$toast({
                message: '备注最多输入100字哦',
                duration: 500
              });
            }
          }


        }
    }
</script>

<style scoped>
  .remarkContainer{
    background: #fff;
    min-height: 100vh;
  }
  .remarks-boder{
    background: #FAFAFA;
    border: 1px solid #D3D3D3;
    border-radius: .02rem;
    margin: .2rem;
    height: 2.4rem;
    width: 7.1rem;
    padding: .3rem .26rem 0 .24rem;
    font-size: .3rem;
  }
  .remark-tag{
    margin: .3rem .2rem 0 .2rem;
    overflow: hidden;
  }
  .tag-items{
    float: left;
    border: 1px solid #D3D3D3;
    border-radius: .32rem;
    margin-right: .2rem;
    padding: .12rem .22rem;
    margin-bottom: .2rem;
    max-width: 7rem;
  }
  .btn-confirm{

  }
</style>



// WEBPACK FOOTER //
// OutRemarks.vue?a91761a6